export class Workflows{
    public static wfs = [
        { // SMS now
            "appliesto": "",
            "attachment": "",
            "attachmentURL": "",
            "calendlyLink": "",
            "created": new Date().toISOString,
            "createdGerman": new Date().toISOString,
            "createdISO": new Date().toISOString,
            "customTime": {}, 
            "document": "",
            "documentURL": "",
            "dothis": "sms",
            "dynamicAttachment": "",
            "emailText": "",
            "emails": [],
            "id": "",
            "information": [],
            "lastChosenWorkflow": "",
            "lastChosenWorkflowMatching": {},
            "name": "SMS",
            "priorityOfWorkflow": "",
            "receiver": "applicant",
            "receivers": [],
            "smsCountryCode": "",
            "smsPhoneNumbers": [],
            "smsText": "",
            "status": "aktiv",
            "subWorkflows": [],
            "when": "now",
            "whenthishappens": "application",
            "workflowSendEmailMessage": "",
            "workflowSendEmailSubject": "nach Eingang der Bewerbung versenden"
        },
        { // Email now
            "appliesto": "",
            "attachment": "",
            "attachmentURL": "",
            "calendlyLink": "",
            "created": new Date().toISOString,
            "createdGerman": new Date().toISOString,
            "createdISO": new Date().toISOString,
            "customTime": {}, 
            "document": "",
            "documentURL": "",
            "dothis": "email",
            "dynamicAttachment": "",
            "emailText": "",
            "emails": [],
            "id": "",
            "information": [],
            "lastChosenWorkflow": "",
            "lastChosenWorkflowMatching": {},
            "name": "EMAIL",
            "priorityOfWorkflow": "",
            "receiver": "applicant",
            "receivers": [],
            "smsCountryCode": "",
            "smsPhoneNumbers": [],
            "smsText": "",
            "status": "aktiv",
            "subWorkflows": [],
            "when": "now",
            "whenthishappens": "application",
            "workflowSendEmailMessage": "",
            "workflowSendEmailSubject": "nach Eingang der Bewerbung versenden"
        },
        { // EMAIL 4 hours
            "appliesto": "",
            "attachment": "",
            "attachmentURL": "",
            "calendlyLink": "",
            "created": new Date().toISOString,
            "createdGerman":new Date().toISOString,
            "createdISO": new Date().toISOString,
            "customTime": {}, 
            "document": "",
            "documentURL": "",
            "dothis": "email",
            "dynamicAttachment": "",
            "emailText": "",
            "emails": [],
            "id": "",
            "information": [],
            "lastChosenWorkflow": "",
            "lastChosenWorkflowMatching": {},
            "name": "EMAIL4H",
            "priorityOfWorkflow": "",
            "receiver": "applicant",
            "receivers": [],
            "smsCountryCode": "",
            "smsPhoneNumbers": [],
            "smsText": "",
            "status": "aktiv",
            "subWorkflows": [],
            "when": "applicantFourHours",
            "whenthishappens": "application",
            "workflowSendEmailMessage": "",
            "workflowSendEmailSubject": "nach Eingang der Bewerbung versenden"
          },
          { // SMS 24 hours
            "appliesto": "",
            "attachment": "",
            "attachmentURL": "",
            "calendlyLink": "",
            "created": new Date().toISOString,
            "createdGerman": new Date().toISOString,
            "createdISO": new Date().toISOString,
            "customTime": {}, 
            "document": "",
            "documentURL": "",
            "dothis": "email",
            "dynamicAttachment": "",
            "emailText": "",
            "emails": [],
            "id": "",
            "information": [],
            "lastChosenWorkflow": "",
            "lastChosenWorkflowMatching": {},
            "name": "Email24H",
            "priorityOfWorkflow": "",
            "receiver": "applicant",
            "receivers": [],
            "smsCountryCode": "",
            "smsPhoneNumbers": [],
            "smsText": "",
            "status": "aktiv",
            "subWorkflows": [],
            "when": "applicantTwentyfourHours",
            "whenthishappens": "application",
            "workflowSendEmailMessage": "",
            "workflowSendEmailSubject": "nach Eingang der Bewerbung versenden"
          },
          { // Call now
            "appliesto": "",
            "attachment": "",
            "attachmentURL": "",
            "calendlyLink": "",
            "created": new Date().toISOString,
            "createdGerman": new Date().toISOString,
            "createdISO": new Date().toISOString,
            "customTime": {}, 
            "document": "",
            "documentURL": "",
            "dothis": "phone",
            "dynamicAttachment": "",
            "emailText": "",
            "emails": [],
            "id": "",
            "information": [],
            "lastChosenWorkflow": "",
            "lastChosenWorkflowMatching": {},
            "name": "PHONE",
            "priorityOfWorkflow": "",
            "receiver": "applicant",
            "receivers": [],
            "smsCountryCode": "",
            "smsPhoneNumbers": [],
            "smsText": "",
            "status": "aktiv",
            "subWorkflows": [],
            "when": "now",
            "whenthishappens": "application",
            "workflowSendEmailMessage": "",
            "workflowSendEmailSubject": "nach Eingang der Bewerbung versenden"
        }
        ]
}